import Vue from "vue"
import ld from "lodash"

Vue.filter("sentenceCase", (value: string) => {
    return ld.upperFirst(ld.lowerCase(value))
})
